import { t as __exportAll } from "./chunk-CfYAbeIz.mjs";
import Ajv from "ajv";
import * as R from "ramda";
//#region src/ajv-extensions.js
var ajv_extensions_exports = /* @__PURE__ */ __exportAll({
	createValidator: () => createValidator,
	processErrors: () => processErrors
});
const createValidator = (schema, ...referenceSchemas) => {
	const checkForSchemaTitle = (s) => throwUnless(R.has("title", s), internalError(`Schema ${s.$id} has no title`));
	checkForSchemaTitle(schema);
	referenceSchemas.map(checkForSchemaTitle);
	const ajv = new Ajv({
		allErrors: true,
		verbose: true,
		useDefaults: true,
		extendRefs: "fail"
	});
	referenceSchemas.forEach((s) => ajv.addSchema(s));
	const validate = ajv.compile(schema);
	return (data) => validate(data) ? void 0 : processErrors(validate.errors);
};
const internalError = (s, found) => `AjvExtensions error: ${s}; found: ${JSON.stringify(found)}`;
const throwUnless = (b, errorMessage) => {
	if (!b) throw new Error(errorMessage);
	return b;
};
const ajvErrorAsString = (error, padLength) => {
	const ellipses = (s) => s.length > 100 ? `${s.substring(0, 100)}...` : s;
	const errorString = (dataPath, message, actual, params = "") => `    ${dataPath} ${message} ${params}; found ${ellipses(JSON.stringify(actual))}`;
	const nameOfIfClause = () => {
		const result = R.path(["schema", "$ref"], error);
		throwUnless(result, internalError(`"if" doesn't include a "$ref"`, parentSchema));
		throwUnless(result.match(/.*\/is/), internalError(`"if" doesn't include "is" in its name"`, parentSchema));
		return result.replace(/.*\/is/, "");
	};
	const { message, params, keyword, data, parentSchema } = error;
	const dataPath = error.schemaPath.padEnd(padLength);
	switch (keyword) {
		case "required": return errorString(dataPath, `A "${parentSchema.title}" must have property "${params.missingProperty}"`, data);
		case "additionalProperties": return errorString(dataPath, `A "${parentSchema.title}" may not have property "${params.additionalProperty}"`, data);
		case "if": return errorString(dataPath, `data with type "${nameOfIfClause()}" didn't conform to definition of "${nameOfIfClause()}"`, data);
		case "pattern": return errorString(dataPath, `  didn't match pattern "${params.pattern}"`, data);
		case "type": return errorString(dataPath, `  isn't "${params.type}"`, data);
		case "anyOf": return errorString(dataPath, `didn't match any possibility`, data);
		case "oneOf": return errorString(dataPath, `didn't match any possibility`, data);
		default: return errorString(dataPath, message, data, ellipses(JSON.stringify(params)));
	}
};
const processErrors = (errors) => {
	const dataPathStringLengths = R.map((e) => e.schemaPath.length, errors);
	const maxStringLength = Math.max(...dataPathStringLengths);
	return errors.map((e) => ajvErrorAsString(e, maxStringLength));
};
//#endregion
export { createValidator, processErrors, ajv_extensions_exports as t };
